/* bristm-feature-tabs — accessible tabs with optional autoplay progress
   (same behaviour as bristm-apps). Loaded only where the section renders. */
(function () {
  if (window.BRISTM_FTABS) return;
  window.BRISTM_FTABS = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initTabs(root) {
    if (root.dataset.bBound) return;
    root.dataset.bBound = '1';

    var bar = root.querySelector('.b-ftabs__tabs');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-b-ftabs-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-b-ftabs-panel]'));
    if (!tabs.length) return;

    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduce.matches && tabs.length > 1;
    var current = Math.max(0, tabs.findIndex(function (t) { return t.classList.contains('is-active'); }));
    var hover = false;
    var focus = false;
    var offscreen = true;
    var editorHold = false;
    var docHidden = document.hidden;

    root.classList.toggle('is-autoplay', autoplay);

    function syncPause() {
      root.classList.toggle('is-paused', hover || focus || offscreen || editorHold || docHidden);
    }

    function run(tab) {
      tabs.forEach(function (t) { t.classList.remove('is-running'); });
      if (!autoplay) return;
      void tab.offsetWidth; /* restart the CSS animation */
      tab.classList.add('is-running');
    }

    function activate(index, opts) {
      opts = opts || {};
      index = (index + tabs.length) % tabs.length;
      current = index;
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (panel, i) {
        var on = i === index;
        panel.classList.toggle('is-active', on);
        if (on) panel.removeAttribute('inert');
        else panel.setAttribute('inert', '');
      });
      if (opts.focus) tabs[index].focus();
      if (opts.scroll && bar && bar.scrollWidth > bar.clientWidth) {
        bar.scrollTo({ left: tabs[index].offsetLeft - bar.offsetLeft, behavior: reduce.matches ? 'auto' : 'smooth' });
      }
      run(tabs[index]);
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(i);
      });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = current + 1;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = current - 1;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        e.preventDefault();
        activate(next, { focus: true, scroll: true });
      });
      var fill = tab.querySelector('.b-ftabs__bar-fill');
      if (fill) {
        fill.addEventListener('animationend', function () {
          if (autoplay && tab.classList.contains('is-running')) activate(current + 1, { scroll: !offscreen });
        });
      }
    });

    [bar, root.querySelector('.b-ftabs__panels')].forEach(function (zone) {
      if (!zone) return;
      zone.addEventListener('mouseenter', function () { hover = true; syncPause(); });
      zone.addEventListener('mouseleave', function () { hover = false; syncPause(); });
      zone.addEventListener('focusin', function (e) {
        /* keyboard focus pauses; a mouse click on a tab keeps autoplay running */
        var t = e.target;
        focus = !!(t && t.matches && t.matches(':focus-visible'));
        syncPause();
      });
      zone.addEventListener('focusout', function (e) {
        if (!zone.contains(e.relatedTarget)) { focus = false; syncPause(); }
      });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          offscreen = !entries[0].isIntersecting;
          syncPause();
        },
        { threshold: 0.25 }
      ).observe(root);
    } else {
      offscreen = false;
    }

    /* Theme editor: selecting a tab block opens (and holds) it */
    root.addEventListener('shopify:block:select', function (e) {
      var i = tabs.findIndex(function (t) { return t.getAttribute('data-block-id') === (e.detail && e.detail.blockId); });
      if (i < 0) return;
      editorHold = true;
      activate(i);
      syncPause();
    });
    root.addEventListener('shopify:block:deselect', function () {
      editorHold = false;
      syncPause();
    });

    document.addEventListener('visibilitychange', function () {
      docHidden = document.hidden;
      syncPause();
    });

    syncPause();
    activate(current);
  }

  function init(scope) {
    var s = scope || document;
    if (s.matches && s.matches('[data-b-ftabs]')) initTabs(s);
    s.querySelectorAll('[data-b-ftabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
